import { NavLink } from '@mantine/core';
import React, { ReactNode, useEffect, useState } from 'react';
import { userAuth } from '../../utils/Authorization';

interface NavbarLinkProps {
    href: string;
    label: string;
    icon?: ReactNode;
    requiredRoles?: string[];
}

function NavbarLink({ href, label, icon, requiredRoles }: NavbarLinkProps) {
    const [authorized, setAuthorized] = useState<boolean>(true);

    useEffect(() => {
        if (requiredRoles) {
            const isAuthorized = () => {
                setAuthorized(userAuth.hasRequiredRoles(requiredRoles));
            };

            isAuthorized();
        }
    }, [requiredRoles]);

    return (
        <NavLink
            px={8}
            py={4}
            href={href}
            label={label}
            leftSection={icon}
            active={window.location.pathname === href}
            display={authorized ? "flex" : "none"}
        />
    )
};

export default NavbarLink;